import './Login.css';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '@/store/hooks.ts';
import {clearError, login} from '@/store/slices/authSlice.ts';
import {
  Button,
  ButtonType,
  ButtonVariant,
  FormItem,
  InputType
} from "@fs/uikit-react";

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    isLoading,
    error,
    isAuthenticated,
    user
  } = useAppSelector(state => state.auth);

  // Clear any errors when the component unmounts or when inputs change
  useEffect(() => {
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(login({username, password}));
  };

  // Redirect to the appropriate start page based on user roles (dashboards removed)
  useEffect(() => {
    if (isAuthenticated && user) {
      console.log(`User authenticated with roles ${user.roles.join(', ')}, redirecting to start page`);
      if (user.roles.includes('SYSTEM_ADMIN')) {
        navigate('/system-admin/settings');
      } else if (user.roles.includes('ADMIN')) {
        navigate('/admin/catalogs/users');
      } else if (user.roles.includes('OPERATOR')) {
        navigate('/operator/person');
      } else {
        navigate('/');
      }
    }
  }, [isAuthenticated, user, navigate]);

  return (
    <div className="login-page">
      <div className="login-container">
        <h1 className="login-title">Login</h1>
        {error && <div className="error-message" style={{
          color: 'red',
          marginBottom: '10px'
        }}>{error}</div>}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <FormItem
            label="Username"
            value={username}
            placeholder="Enter your username"
            required
            onChange={(e) => {
              setUsername(e.target.value);
              if (error) dispatch(clearError());
            }}
          />
          <FormItem
            label="Password"
            value={password}
            placeholder="Enter your password"
            type={InputType.PASSWORD}
            required
            onChange={(e) => {
              setPassword(e.target.value);
              if (error) dispatch(clearError());
            }}
          />
          <div className="login-button-container">
            <Button
              type={ButtonType.SUBMIT}
              variant={ButtonVariant.PRIMARY}
              loading={isLoading}
              title={isLoading ? 'Logging in...' : 'Login'}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
